export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/reading_eggspress-4193aa5289440dd75604d4c04051ae81.svg";